<div class="h-100 flex items-center">
  <div
    #container
    [ngClass]="'p-splitbutton p-component'"
    [ngStyle]="style"
    class="{{ styleClass }} "
  >
    <p-button
      *ngIf="!buttonLink"
      type="button"
      [icon]="icon + ' mx-2'"
      [iconPos]="iconPos"
      [label]="label"
      (onClick)="onDefaultButtonClick($event)"
      [disabled]="disabled"
      [attr.tabindex]="tabindex"
      [title]="label"
      styleClass=" p-splitbutton-defaultbutton"
    ></p-button>
    <a
      pButton
      *ngIf="buttonLink"
      [routerLink]="buttonLink"
      [label]="label"
      class="p-splitbutton-defaultbutton"
    >
    </a>
    <p-button
      type="button"
      styleClass="p-splitbutton-menubutton"
      icon="pi pi-chevron-down"
      (onClick)="onDropdownButtonClick($event)"
      [attr.aria-label]="expandAriaLabel"
    ></p-button>
    <p-tieredMenu
      #menu
      appCloseMenuOnScroll
      [menu]="menu"
      [popup]="true"
      [model]="actionsList"
      [style]="menuStyle"
      [styleClass]="menuStyleClass"
      [appendTo]="appendTo"
      [showTransitionOptions]="showTransitionOptions"
      [hideTransitionOptions]="hideTransitionOptions"
      (onShow)="onShowSelectionsList()"
      (onHide)="onHideSelectionsList()"
    >
      <ng-template #item let-item let-hasSubmenu="hasSubmenu">
        @if (item.routerLink) {
          <a
            class="flex items-center p-tieredmenu-item-link"
            [routerLink]="item.routerLink"
            [queryParams]="item.queryParams"
          >
            <ng-container
              *ngTemplateOutlet="
                menuItemContent;
                context: { item: item, hasSubmenu: hasSubmenu }
              "
            />
          </a>
        } @else {
          <a class="flex items-center p-tieredmenu-item-link">
            <ng-container
              *ngTemplateOutlet="
                menuItemContent;
                context: { item: item, hasSubmenu: hasSubmenu }
              "
            />
          </a>
        }
      </ng-template>
    </p-tieredMenu>
  </div>
</div>

<ng-template #menuItemContent let-item="item" let-hasSubmenu="hasSubmenu">
  <span [class]="item.icon" class="p-tieredmenu-item-icon"></span>
  <span class="ms-2">{{ item.label }}</span>
  <app-value-based-tooltip [value]="item.description" position="bottom" />
  <i *ngIf="hasSubmenu" class="pi pi-angle-right ml-auto"></i>
</ng-template>
